<template>
    <li class="nav-item d-flex align-items-center me-2">
        <div class="d-flex align-item-center">
            <div class="user-info-text">
                <p class="name">{{ name }}</p>
                <p class="profile">{{ profile }}</p>
            </div>
            <div>
                <img :src="photo && photo !== '' ? parseValidUrl(photo) : defaultAvatar" class="avatar me-2 border-grey"
                    alt="user image" />
            </div>
        </div>
    </li>
</template>

<script>
import defaultAvatar from '@/assets/img/avatars/user.jpg';
import base from '@/config/base';

export default {
    name: "UserInfo",
    props: {
        name: {
            type: String,
            default: ""
        },
        profile: {
            type: String,
            default: ""
        },
        photo: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            defaultAvatar: defaultAvatar
        };
    },
    methods: {
        parseValidUrl(url) {
            let responseUrl = "";
            if (/^(f|ht)tps?:\/\//i.test(url)) {
                responseUrl = url;
            } else {
                responseUrl = `${base.config.BASE_URL}${url}`
            }
            return responseUrl;
        }
    },
};
</script>

<style scoped>
.nav-item {
    cursor: pointer;
}

.avatar {
    height: 38.40px;
    width: 38.40px;
}

p {
    margin: 0;
    text-align: end;
    line-height: 1.2;
}

.user-info-text {
    padding-right: 1rem;
    position: relative;
    top: 2px;
}

p.name {
    font-weight: 600;
    font-size: 0.95rem;
}

p.profile {
    color: var(--gray-text);
    font-size: 0.9rem;
}
</style>
